import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: '*',
        redirect: '/SellCars'
    },
    {
        name: 'carResultAssessment',
        component: () => import('./view/carResultAssessment'),
        meta: {
            title: '爱车评估结果'
        }
    },
    {
        name: 'user',
        component: () => import('./view/user'),
        meta: {
            title: '会员中心'
        }
    },
    {
        name: 'cart',
        component: () => import('./view/cart'),
        meta: {
            title: '购物车'
        }
    },
    {
        name: 'goods',
        component: () => import('./view/goods'),
        meta: {
            title: '商品详情'
        }
    },
    {
        name: 'SellCars',
        component: () => import('./view/SellCars'),
        meta: {
            title: '爱车直卖'
        }
    },
    {
        name: 'SellCars/Succeed',
        component: () => import('./view/SellCars/succeed'),
        meta: {
            title: '提交成功'   //爱车直卖
        }
    },
    {
        name: 'SellCars/Publish',
        component: () => import('./view/SellCars/publish'),
        meta: {
            title: '直卖发布'
        }
    },
    {
        name: 'Collect',
        component: () => import('./view/Collect'),
        meta: {
            title: '平台收车'
        }
    },
    {
        name: 'Collect/Valuation',
        component: () => import('./view/Collect/Valuation'),
        meta: {
            title: '爱车估值'
        }
    },
    {
        name: 'Collect/KeyValuation',
        component: () => import('./view/Collect/KeyValuation'),
        meta: {
            title: '一键估值'
        }
    },
    {
        name: 'Collect/Publish',
        component: () => import('./view/Collect/Publish'),
        meta: {
            title: '快速卖车'
        }
    },
    {
        name: 'Collect/Publish/Succeed',
        component: () => import('./view/Collect/Succeed'),
        meta: {
            title: '提交成功'  //快速卖车
        }
    },
    {
        name: 'FindCar',
        component: () => import('./view/FindCar'),
        meta: {
            title: '帮我找车'
        }
    },

    {
        name: 'AccountBinding',
        component: () => import('./view/AccountBinding/AccountBinding'),
        meta: {
            title: '账号绑定'  //账号绑定
        }
    },

    {
        name: 'BManageNotice/refuseReason',
        component: () => import('./view/daihing_B_manage_notice/refuseReason'),
        meta: {
            title: '拒绝原因'
        }
    },
    {
        name: 'BManageNotice/detail',
        component: () => import('./view/daihing_B_manage_notice/detail'),
        meta: {
            title: ''
        }
    },
    {
        name: 'BManageNotice/rate',
        component: () => import('./view/daihing_B_manage_notice/rate'),
        meta: {
            title: '评价'
        }
    },
    {
        path: '/WeChat/empower/:isReceiveCoupon',
        component: () => import('./view/WeChat/empower'),
        meta: {
            title: ''
        }
    },
    {
        name: 'BManageNotice/login',
        component: () => import('./view/daihing_B_manage_notice/login'),
        meta: {
            title: '登录'
        }
    },
    {
        name: 'BManageNotice/myBusiness',
        component: () => import('./view/daihing_B_manage_notice/myBusiness'),
        meta: {
            title: '我的事项'
        }
    },
    {
        name: 'BManageNotice/businessHandlingCenter',
        component: () => import('./view/daihing_B_manage_notice/businessHandlingCenter'),
        meta: {
            title: '事项处理中心'
        }
    },

    {
        name: 'appletOpen',
        component: () => import('./view/appletOpen'),
        meta: {
            title: '打开小程序'
        }
    },

    {
        name: 'onlinePayment',
        component: () => import('./view/miniProgram/onlinePayment/index'),
        meta: {
            title: '确定订单'
        }
    },
    {
        name: 'onlinePayment/pay',
        component: () => import('./view/miniProgram/onlinePayment/pay'),
        meta: {
            title: '收银台'
        }
    },

];

// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }
    next();
});

export {
    router
};
